<data-table [columns]="columns" [dataProviderParams]="dataProviderParams" [dataProvider]="groupService"
                [validator]="{ validate: 'GroupID',  target: selectedGroupIds }" [selectable]="true" (select)="selected($event)"
                title="{{'myUsers.groups' | translate}}">
</data-table>

<div class="button-right-container">
  <button (click)="abort()" class="ibexfusion-raised-button" mat-button>{{'general.cancel' | translate}}</button>
  <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{'general.save' | translate}}</button>
</div>
